<template>
	<div class="line">
		<div ref="linechart" class="linechart"></div>
	</div>
</template>

<script>
import * as methods from './method.js'
export default {
	name: 'template.scope66',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			title: '柱形图-scope66',
			timer: null,
			defaultdata: [
				{ value1: '系列一', value2: '25' },
				{ value1: '系列二', value2: '15' },
				{ value1: '系列三', value2: '25' },
				{ value1: '系列四', value2: '15' },
				{ value1: '系列五', value2: '30' },
				{ value1: '系列六', value2: '30' },
				{ value1: '系列七', value2: '30' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '数值', key: "value2" },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			config: {
			},
		}
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.DrawEcharts()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null
			var echarts = require('echarts');
			var TmyChart = echarts.init(this.$refs.linechart);
			const colormap = ['#045cfa', '#28c8f7', '#00f5b4', '#fad452', '#ff7062', '#57c291', '#6c91c4']
			let total = 0
			let vdata = this.defaultdata.map((item, i) => {
				total += +item.value2
				return {
					name: item.value1,
					value: item.value2,
					itemStyle: {
						color: colormap[i % colormap.length],
					}
				}
			})
			var Toption = {
				legend: {
					orient: 'vertical',
					top: "18%",
					height: '180px',
					right: "0%",
					y: "center",
					itemHeight: 12,
					itemWidth: 12,
					// itemGap:30,
					icon: "rect",
					// itemHeight:"10",
					textStyle: {
						padding: [0, 30, 0, 6],
						lineHeight: 30,
						color: "#fff",
						fontWeight: '400',
						fontSize: '14',
					}
				},
				// 圆环中间的文字
				graphic: [
					{
						type: 'text',
						left: "14%",
						top: '40%',
						style: {
							text: total,
							font: 'bolder 30px "PangMenZhengDao" ',
							fill: '#fff',
							fontFamily: 'PangMenZhengDao',
							fontSize: 30,
							lingHeight: 17,
						}
					},
					{
						type: 'text',
						left: "15%",
						top: '55%',
						style: {
							text: '种植总数',
							fill: '#969696',
							width: 30,
							height: 30,
							fontSize: 16,
						}
					}
				],
				series: [
					{
						type: 'pie',
						center: ['22%', '50%'],
						radius: ['58%', '75%'],
						avoidLabelOverlap: false,
						itemStyle: {
							normal: {
								borderColor: '#000',
								borderWidth: 2,
								color: vdata.itemStyle
							}
						},
						label: {
							normal: {
								show: false,
							},
							emphasis: {
								show: false,
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: vdata
					}
				]

			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(function () {
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000)
		},
	},
	created() {

	},
	mounted() {
		// if (this.vdata && this.vdata.length) {
		// 	this.defaultdata = this.vdata
		// }
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
		this.DrawEcharts(); //需要刷新的数据
	},
}
</script>

<style scoped>
.line {
	width: 435px;
	height: 240px;
	display: flex;
	position: relative;
	overflow: hidden;
	padding: 10px 0;
}

.linechart {
	width: 100%;
	height: 100%;

}
</style>